
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { MetadataType, OrdineSlim } from '@/models';

@Component
export default class ItemListOrdine extends Vue {
    @Prop() private ordine!: OrdineSlim;

    private iconClassByProgress(ord: OrdineSlim): string {
        if (ord.progresso == 0) {
            return 'grey';
        } else if (ord.progresso == 100) {
            return 'green';
        }

        return 'amber';
    }
    private getChipColorByHashedString(nome: string): string {
        const colorArray = ["grey", "red", "pink", "purple", "deep-purple", "indigo", "blue",
        "light-blue", "cyan", "teal", "green", "light-green", "lime", "yellow", "amber",
        "orange", "deep-orange", "brown", "blue-grey"];
        var hash = 0, i, chr;
        for (i = 0; i < nome.length; i++) {
            chr   = nome.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        if(hash < 0) hash = -hash;
        return colorArray[hash % colorArray.length];
    }
    private metadataType = MetadataType;

    private showDetail(ordine: OrdineSlim) {
        this.$router.push({ name: 'ordine', params: { id: ordine.id }});
    }
}
